import { useState } from 'react';

export interface LinhaPerfil {
  chave: string;
  rotulo: string;
  /** Diferenca padronizada B - A, em desvios-padrao da populacao. */
  z: number;
  textoA: string;
  textoB: string;
  textoDelta: string;
}

/**
 * Perfil de diferencas: uma barra por medida a partir de um eixo central.
 * Para a esquerda, A e maior; para a direita, B e maior. Uma cor so — a direcao
 * e dada pela posicao, e o lado vem escrito no cabecalho, nunca so pela cor.
 */
export function PerfilDiferencas({ linhas, rotuloA, rotuloB }: { linhas: LinhaPerfil[]; rotuloA: string; rotuloB: string }) {
  const [foco, setFoco] = useState<LinhaPerfil | null>(null);
  const maximo = Math.max(1, ...linhas.map((l) => Math.abs(l.z)));

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-3 text-xs font-semibold tracking-wide text-apagado uppercase">
        <span />
        <span className="flex justify-between">
          <span>← {rotuloA} maior</span>
          <span>{rotuloB} maior →</span>
        </span>
      </div>

      <ul className="space-y-px" onMouseLeave={() => setFoco(null)}>
        {linhas.map((l) => {
          const largura = `${(Math.abs(l.z) / maximo) * 50}%`;
          return (
            <li
              key={l.chave}
              onMouseEnter={() => setFoco(l)}
              onFocus={() => setFoco(l)}
              tabIndex={0}
              aria-label={`${l.rotulo}: ${rotuloA} ${l.textoA}, ${rotuloB} ${l.textoB}, diferença ${l.textoDelta}`}
              className={`grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)] items-center gap-3 py-0.5 outline-none ${
                foco?.chave === l.chave ? 'bg-destaque-fundo' : ''
              }`}
            >
              <span className="truncate text-right text-[13px]">{l.rotulo}</span>
              <span className="relative h-4">
                <span aria-hidden className="absolute inset-y-0 left-1/2 w-px bg-borda-forte" />
                <span
                  aria-hidden
                  className="absolute inset-y-0.5 bg-destaque"
                  style={l.z < 0 ? { right: '50%', width: largura } : { left: '50%', width: largura }}
                />
              </span>
            </li>
          );
        })}
      </ul>

      <p className="numero min-h-10 border-t border-borda pt-2 text-[13px] text-apagado" aria-live="polite">
        {foco ? (
          <>
            <strong className="font-semibold text-texto">{foco.rotulo}</strong> · {rotuloA} {foco.textoA} · {rotuloB}{' '}
            {foco.textoB} · Δ {foco.textoDelta}
          </>
        ) : (
          'Passe o mouse (ou use Tab) sobre uma medida para ver os valores. Barras em desvios-padrão do plantel.'
        )}
      </p>
    </div>
  );
}
